import React, { useEffect, useMemo, useState } from "react";
// import PageHeader from "../../components/PageHeader/PageHeader";
import PageHeader from "../../Components/PageHeader/PageHeader";
// import CommonTable from "../../components/CommonTable/CommonTable";
import { FaEye, FaSearch, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router";
import { URLS } from "../../Services/Constant";
import { deletes, get, put } from "../../Services/ApiHandler";
import toast from "react-hot-toast";
// import DeleteModal from "../../components/DeleteModal/DeleteModal";
// import usePermission from "../../customHook/usePermission";
import usePermission from "../../Components/customHook/usePermission";
import Header from "../../Components/Header";
import MaterialTable from "../../Components/Table/MaterialTable";
import {
  defaultImg,
  deletee,
  leftArrow,
  tableEye,
} from "../../common/Assets/imgs";
import DeleteModal from "../../Components/DeleteModal/DeleteModal";

const Contact = () => {
  const [page, setPage] = useState(1);
  const [isData, setIsData] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedFAQ, setSelectedFAQ] = useState(null);
  const navigate = useNavigate();
  const permission = usePermission();
  const [image, setImage] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
      const [pagination, setPagination] = useState(1);

  const removeImage = () => {
    setImage(null);
  };
  // const [adminList, setAdminList] = useState([
  //     {
  //       sno: "01",
  //       adminId: "KD075821",
  //       adminName: "Vikram",
  //       role: "Admin",
  //       mobile: "+91 8965346856",
  //       status: "Active",
  //     },
  //     {
  //       sno: "02",
  //       adminId: "KD075822",
  //       adminName: "Surya",
  //       role: "Super Admin",
  //       mobile: "+91 8965346856",
  //       status: "Active",
  //     },
  //     {
  //       sno: "03",
  //       adminId: "KD075823",
  //       adminName: "Ajay",
  //       role: "Sub Admin",
  //       mobile: "+91 8965346856",
  //       status: "De-Active",
  //     },
  //   ]);
  const [adminList, setAdminList] = useState([]);
  const handleView = (row) => {
    if (!row) return;
    navigate("/faq-edit", { state: { data: row, mode: "view" } });
  };

  const handleDelete = (row) => {
    if (!row) return;
    setSelectedFAQ(row);
    setIsDeleteModalOpen(true);
  };

  // const confirmDelete = async () => {
  //   try {
  //     if (selectedFAQ?.id) {
  //       let res = await deletes(URLS.FAQ_LIST + selectedFAQ.id + "/");
  //       if (res?.status === "success") {
  //         toast.success(res?.message || "Deleted successfully");
  //         fetchDataFAQ();
  //       } else {
  //         toast.error(res?.message || "Failed to delete");
  //       }
  //       setIsDeleteModalOpen(false);
  //       setSelectedFAQ(null);
  //     }
  //   } catch (error) {
  //     console.error("Error deleting FAQ:", error);
  //     toast.error(error?.message || "An error occurred");
  //   }
  // };

  // const statusChanger = (id, currentStatus) => {
  //   put(`${URLS.ADMIN_STATUS}${id}/`, {
  //     status: currentStatus === 1 ? 0 : 1,
  //   })
  //     .then((res) => {
  //       if (res?.status === "success") {
  //         toast.success(res?.message);
  //         // getList(); // refresh table
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("err", err);
  //     });
  // };

  // const handlerStatusUpdate = async (row) => {
  //   try {
  //     if (!row?.id) return;
  //     const res = await put(URLS.FAQ_LIST + row.id + "/", {
  //       status: row.status === 1 ? 0 : 1,
  //       question: row?.question || "",
  //       answer: row?.answer || "",
  //     });
  //     if (res?.status === "success") {
  //       toast.success(res?.message || "Status updated successfully");
  //       fetchDataFAQ();
  //     } else {
  //       toast.error(res?.message || "Failed to update status");
  //     }
  //   } catch (error) {
  //     console.error("Error updating FAQ status:", error);
  //     toast.error(error?.message || "An error occurred");
  //   }
  // };

  const pageSize = 10;

  const columns = [
    {
      header: "S.No",
           accessorFn: (row, index) =>
    (pagination - 1) * pageSize + index + 1,
      // accessorFn: (row, index) => index + 1,
      id: "serial_no",
    },
    {
      accessorKey: "persion_code",
      header: "Person ID",
    },
    {
      accessorKey: "name",
      header: "Admin Name",
    },
    {
      accessorKey: "email",
      header: "Email ID",
    },
    {
      accessorKey: "mobile",
      header: "Mobile Number",
    },

    //  {
    //     header: "Status",
    //     accessorKey: "status",
    //     Cell: ({ cell, row }) => {
    //       return (
    //         <button
    //           className={`border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
    //         ${cell.getValue() ? "active-btn" : "deactive-btn"} `}
    //           onClick={() => statusChanger(row?.original?.id, row?.original?.status)}
    //         >
    //           {cell.getValue() ? "Active" : "Deactive"}
    //         </button>
    //       );
    //     },
    //   },
    {
      id: "action", // ✅ important when no accessorKey
      header: "Action",
      Cell: ({ row }) => (
        <div className="gap-2 d-flex justify-content-center">
          <img
            src={tableEye}
            alt=""
            className="tableeye"
            onClick={() =>
              navigate("/add-contact", {
                state: {
                  data: row.original,
                  type: "view",
                },
              })
            }
          />
          {/* <img src={tableEye} alt="" className="tableeye" /> */}
          <img
            src={deletee}
            alt=""
            className="deleteicon"
            onClick={() => handleDelete(row?.original)}
          />
        </div>
      ),
    },
  ];

  const fetchDataFAQ = async (src) => {
    try {
      setLoader(true);
      // let res= await get (URLS.CONTACTS_LIST)
      let res = await get(`${URLS.CONTACTS_LIST}?search=${src}`);
      if (res?.status === "success") {
        setIsData(res?.data || []);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching FAQ list:", error);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchDataFAQ(search);
  }, [search]);

  console.log(":isData", isData);

  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setImage({
  //       file,
  //       preview: URL.createObjectURL(file),
  //     });
  //   }
  // };

  // const handleDelete = (row) => {
  //   if (!row) return;
  //   setSelectedFAQ(row);
  //   setIsDeleteModalOpen(true);
  // };

  const confirmDelete = async () => {
    console.log('selectedFAQ?.id', selectedFAQ);
    
    try {
      setIsLoading(true);
      if (selectedFAQ?.persion_code) {
         let res = await deletes(URLS.CONTACTS_DELETE + selectedFAQ.persion_code + "/");
        //  let res = await deletes(URLS.FAQ_LIST + selectedFAQ.persion_code + "/");
        // let res = await deletes(`${URLS.CONTACTS_DELETE}${persion_code}/ `);
        // let res = await deletes(URLS.CONTACTS_DELETE + selectedFAQ.persion_code + "/");
        console.log('DELETE',URLS.CONTACTS_DELETE + selectedFAQ.persion_code + "/");
        if (res?.status === "success") {
          toast.success(res?.message || "Deleted successfully");
           fetchDataFAQ(search);
            setIsData((prev) =>
          prev.filter(
            (item) => item.persion_code !== selectedFAQ.persion_code
          )
        );
        } else {
          toast.error(res?.message || "Failed to delete");
        }
        setIsDeleteModalOpen(false);
        setSelectedFAQ(null);
      }
    } catch (error) {
      console.error("Error deleting FAQ:", error);
      toast.error(error?.message || "An error occurred");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Header title={"Contact US"} />
      <div
        style={{ marginTop: "5rem", paddingLeft: "10px", paddingRight: "10px" }}
      >
        {/* <PageHeader
        title="FAQ"
        buttonText="+Add FAQ"
        buttonPath="/faq-edit"
        permissionAllowed={"CAN-ADD-FAQ"}
      /> */}

        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 pt-4 px-1">
          {/* LEFT TITLE */}
          <h3 className="m-0 fw-bold fs-5 text-black">Contact Us</h3>

          {/* RIGHT SECTION */}
          <div className="d-flex align-items-center gap-3">
            {/* SEARCH BOX */}
            <div className="search-box d-flex align-items-center px-3">
              <input
                type="text"
                placeholder="Search"
                className="border-0 outline-none bg-transparent"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div className="ms-2 searchdote">|</div>
              <FaSearch color="#7A52AB" className="ms-1" />
            </div>

            {/* ADD BUTTON */}
            <button
              onClick={() =>
                navigate("/add-contact", {
                  state: {
                    type: "add",
                  },
                })
              }
              style={{ backgroundColor: "#F98425" }}
              className="btn text-white fw-semibold px-4 py-2"
            >
              + Add Contact
            </button>
          </div>
        </div>
      </div>

      {/* <CommonTable
        columns={columns}
        data={isData || []}
        showPagination={false}
      /> */}
      <div className="mx-3">
        <MaterialTable columns={columns} data={isData || []} loading={loader} />
      </div>
      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete?"
        isLoading={isLoading}
      />
    </>
  );
};

export default Contact;
